"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleReport = exports.getUserReportsSuccess = exports.getUserReportsRequested = exports.getUserReports = exports.getUserReportWriterResultsSuccess = exports.getUserReportWriterResultsRequested = exports.getUserReportWriterResults = exports.generateReport = exports.cancelReport = exports.addReport = exports.GET_USER_REPORT_WRITER_RESULTS_SUCCESS = exports.GET_USER_REPORT_WRITER_RESULTS_REQUESTED = exports.GET_USER_REPORT_WRITER_RESULTS_ERROR = exports.GET_USER_REPORTS_SUCCESS = exports.GET_USER_REPORTS_REQUESTED = exports.GET_USER_REPORTS_ERROR = exports.ADD_REPORT = void 0;
var _apiActions = require("./apiActions");
var _snackbarActions = require("./snackbarActions");
var _sidePaneActions = require("./sidePaneActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GET_USER_REPORTS_REQUESTED = exports.GET_USER_REPORTS_REQUESTED = 'GET_USER_REPORTS_REQUESTED';
var GET_USER_REPORTS_SUCCESS = exports.GET_USER_REPORTS_SUCCESS = 'GET_USER_REPORTS_SUCCESS';
var GET_USER_REPORTS_ERROR = exports.GET_USER_REPORTS_ERROR = 'GET_USER_REPORTS_ERROR';
var GET_USER_REPORT_WRITER_RESULTS_REQUESTED = exports.GET_USER_REPORT_WRITER_RESULTS_REQUESTED = 'GET_USER_REPORT_WRITER_RESULTS_REQUESTED';
var GET_USER_REPORT_WRITER_RESULTS_SUCCESS = exports.GET_USER_REPORT_WRITER_RESULTS_SUCCESS = 'GET_USER_REPORT_WRITER_RESULTS_SUCCESS';
var GET_USER_REPORT_WRITER_RESULTS_ERROR = exports.GET_USER_REPORT_WRITER_RESULTS_ERROR = 'GET_USER_REPORT_WRITER_RESULTS_ERROR';
var ADD_REPORT = exports.ADD_REPORT = 'ADD_REPORT';
var getUserReports = exports.getUserReports = function getUserReports(UserId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch) {
      var reports;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(getUserReportsRequested());
            _context.next = 3;
            return dispatch((0, _apiActions.callAPI)('GetUserReportTickets', {
              UserId: UserId
            }));
          case 3:
            reports = _context.sent;
            dispatch(getUserReportsSuccess(reports));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getUserReportsRequested = exports.getUserReportsRequested = function getUserReportsRequested() {
  return {
    type: GET_USER_REPORTS_REQUESTED
  };
};
var getUserReportsSuccess = exports.getUserReportsSuccess = function getUserReportsSuccess(payload) {
  return {
    type: GET_USER_REPORTS_SUCCESS,
    payload: payload
  };
};
var getUserReportWriterResults = exports.getUserReportWriterResults = function getUserReportWriterResults() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var UserId, reports;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            dispatch(getUserReportWriterResultsRequested());
            _context2.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetUserReportWriterResultRecords', {
              UserId: UserId
            }));
          case 4:
            reports = _context2.sent;
            dispatch(getUserReportWriterResultsSuccess(reports));
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getUserReportWriterResultsRequested = exports.getUserReportWriterResultsRequested = function getUserReportWriterResultsRequested() {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_REQUESTED
  };
};
var getUserReportWriterResultsSuccess = exports.getUserReportWriterResultsSuccess = function getUserReportWriterResultsSuccess(payload) {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_SUCCESS,
    payload: payload
  };
};
var createParamsForOneOffReport = function createParamsForOneOffReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    startTime: (0, _add_days["default"])(formValues.startDate, 1),
    endTime: (0, _add_days["default"])(formValues.endDate, 1),
    accountIdList: formValues.accountIdList
  };
};
var generateReport = exports.generateReport = function generateReport(formValues) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var params, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            params = createParamsForOneOffReport(getState, formValues);
            _context3.t0 = formValues.type;
            _context3.next = _context3.t0 === 'TradeActivity' ? 4 : _context3.t0 === 'Transaction' ? 8 : _context3.t0 === 'Treasury' ? 12 : _context3.t0 === 'ProductDelta' ? 16 : _context3.t0 === 'PnL' ? 20 : 24;
            break;
          case 4:
            _context3.next = 6;
            return dispatch((0, _apiActions.callAPI)('GenerateTradeActivityReport', params));
          case 6:
            response = _context3.sent;
            return _context3.abrupt("break", 26);
          case 8:
            _context3.next = 10;
            return dispatch((0, _apiActions.callAPI)('GenerateTransactionActivityReport', params));
          case 10:
            response = _context3.sent;
            return _context3.abrupt("break", 26);
          case 12:
            _context3.next = 14;
            return dispatch((0, _apiActions.callAPI)('GenerateTreasuryActivityReport', params));
          case 14:
            response = _context3.sent;
            return _context3.abrupt("break", 26);
          case 16:
            _context3.next = 18;
            return dispatch((0, _apiActions.callAPI)('GenerateProductDeltaActivityReport', params));
          case 18:
            response = _context3.sent;
            return _context3.abrupt("break", 26);
          case 20:
            _context3.next = 22;
            return dispatch((0, _apiActions.callAPI)('GeneratePnLActivityReport', params));
          case 22:
            response = _context3.sent;
            return _context3.abrupt("break", 26);
          case 24:
            console.error("Unsupported '".concat(formValues.type, "' report type"));
            return _context3.abrupt("return");
          case 26:
            if (!(response.bAccepted === false)) {
              _context3.next = 28;
              break;
            }
            return _context3.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'REPORT_WARNING',
              type: 'warning',
              text: response.rejectMessage
            })));
          case 28:
            dispatch(addReport(response));
            dispatch((0, _sidePaneActions.closeReportsSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'SINGLE_REPORT_SUCCESS',
              type: 'success',
              // t('Single report was successfully created')
              text: 'Single report was successfully created'
            }));
          case 31:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var createParamsForScheduledReport = function createParamsForScheduledReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    frequency: formValues.frequency,
    beginTime: formValues.startDate,
    accountIdList: formValues.accountIdList
  };
};
var scheduleReport = exports.scheduleReport = function scheduleReport(formValues) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var params, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            params = createParamsForScheduledReport(getState, formValues);
            _context4.t0 = formValues.type;
            _context4.next = _context4.t0 === 'TradeActivity' ? 4 : _context4.t0 === 'Transaction' ? 8 : _context4.t0 === 'Treasury' ? 12 : _context4.t0 === 'ProductDelta' ? 16 : _context4.t0 === 'PnL' ? 20 : 24;
            break;
          case 4:
            _context4.next = 6;
            return dispatch((0, _apiActions.callAPI)('ScheduleTradeActivityReport', params));
          case 6:
            response = _context4.sent;
            return _context4.abrupt("break", 26);
          case 8:
            _context4.next = 10;
            return dispatch((0, _apiActions.callAPI)('ScheduleTransactionActivityReport', params));
          case 10:
            response = _context4.sent;
            return _context4.abrupt("break", 26);
          case 12:
            _context4.next = 14;
            return dispatch((0, _apiActions.callAPI)('ScheduleTreasuryActivityReport', params));
          case 14:
            response = _context4.sent;
            return _context4.abrupt("break", 26);
          case 16:
            _context4.next = 18;
            return dispatch((0, _apiActions.callAPI)('ScheduleProductDeltaActivityReport', params));
          case 18:
            response = _context4.sent;
            return _context4.abrupt("break", 26);
          case 20:
            _context4.next = 22;
            return dispatch((0, _apiActions.callAPI)('ScheduleProfitAndLossActivityReport', params));
          case 22:
            response = _context4.sent;
            return _context4.abrupt("break", 26);
          case 24:
            console.error("Unsupported '".concat(formValues.type, "' report type"));
            return _context4.abrupt("return");
          case 26:
            if (!(response.bAccepted === false)) {
              _context4.next = 28;
              break;
            }
            return _context4.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'CYCLICAL_REPORT_ERROR',
              type: 'warning',
              text: response.rejectMessage
            })));
          case 28:
            dispatch(addReport(response));
            dispatch((0, _sidePaneActions.closeReportsSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'CYCLICAL_REPORT_SUCCESS',
              type: 'success',
              // t('Cyclical report was successfully created')
              text: 'Cyclical report was successfully created'
            }));
          case 31:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var addReport = exports.addReport = function addReport(payload) {
  return {
    type: ADD_REPORT,
    payload: payload
  };
};
var cancelReport = exports.cancelReport = function cancelReport(UserReportId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var UserId, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context5.next = 3;
            return dispatch((0, _apiActions.callAPI)('CancelUserReport', {
              UserReportId: UserReportId
            }));
          case 3:
            response = _context5.sent;
            if (response.result) {
              dispatch(getUserReports(UserId));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'CANCEL_REPORT_ERROR',
                text: (0, _errorTextFormatter.formatErrorText)(response),
                type: 'warning'
              }));
            }
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};